import React, { useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Paper,
    Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const BuyerPolicySecurity = () => {
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);



    return (
        <div className="container mt-4">
            <div className="card p-4">
                <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
                    <div className="header-text">
                        <div className="head-text" >
                            Privacy & Security Settings
                        </div>
                        <div className="head-subtext" style={{ color: '#666' }}>
                            Adjust your privacy and security options.
                        </div>
                    </div>

                </div>
                <div className='accordion-sec'>
                    <Box className="container p-2">
                        <Paper elevation={1} sx={{ p: 2 }}>
                            <Typography  gutterBottom sx={{ fontWeight: 700, mb: 2, fontSize:'20px' }}>
                                General Information
                            </Typography>

                            <Accordion defaultExpanded>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#e8edf3' }}>
                                    <Typography variant="subtitle1" fontWeight={600}>
                                        Terms of Service
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography paragraph>
                                        Welcome to our platform! These Terms of Service ("Terms") govern your use of the AMTPL Admin UI Mockup and its related services. By accessing or using our services, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the service.  </Typography>
                                    <Typography paragraph>
                                        We reserve the right to update or modify these Terms at any time without prior notice. Your continued use of the service after any such changes constitutes your acceptance of the new Terms. It is your responsibility to review these Terms periodically for changes.</Typography>
                                    <Typography paragraph>
                                        This platform is intended for administrative purposes only. Unauthorized access, use, or modification of this system is strictly prohibited and may result in legal action. All content and features are provided "as is" without warranty of any kind.
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f7fa' }}>
                                    <Typography variant="subtitle1" fontWeight={600}>
                                        Privacy Policy
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography paragraph>
                                        Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services. Please read this Privacy Policy carefully. If you do not agree with the terms of this Privacy Policy, please do not access the site.
                                    </Typography>
                                    <Typography paragraph>
                                        We collect personal information that you voluntarily provide to us when you register on the Services, express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.</Typography>
                                    <Typography paragraph>
                                        We implement a variety of security measures to maintain the safety of your personal information. However, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure. We may update this policy from time to time. </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </Paper>
                    </Box>
                </div>
            </div>
        </div>
    );
};

export default BuyerPolicySecurity;
